import styled from "styled-components";

import TreeView from "@material-ui/lab/TreeView";

export const StyledTreeView = styled(TreeView)`
  height: auto;
  flex-grow: 1;
  max-width: 400px;
`;
